export default __webpack_public_path__ + "static/media/search_data_not_found.f319caa3.svg";